import { OrganizationName } from 'constants/organization/types';
import styled from 'styled-components';

type StyledImageProps = {
    appName: string;
    logoHeight?: string;
    logoWidth?: string;
};
const getWidth = (props: StyledImageProps) => {
    if (props.appName === OrganizationName.COLLECTIONS) {
        return '135px';
    }
    if (props.logoWidth) {
        return props.logoWidth;
    }
    return 'unset';
};
const getHeight = (props: StyledImageProps) => {
    if (props.appName === OrganizationName.COLLECTIONS) {
        return '30px';
    }
    if (props.logoHeight) {
        return props.logoHeight;
    }
    return 'unset';
};

export const StyledImage = styled.img<StyledImageProps>`
    display: unset;
    height: ${getHeight};
    width: ${getWidth};
`;
